import React from 'react';
import styles from './ProgressBar.component.module.scss';

const defaultProps: Props = { percentFill: 0 };

interface Props {
  percentFill?: number;
  style?: any;
}

export const ProgressBar: React.FC<Props> = (props = defaultProps) => {
  return (
    <div className={styles.progressBar}>
      <div className={styles.progressBarBg}>
        <div className={styles.progressBarFill} style={{ width: `${props.percentFill}%` }} />
      </div>
    </div>
  );
};

export default ProgressBar;
